import React from "react";
import FormInput from "Common/Custom/FormInput";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import FormSelect from "Common/Custom/FormSelect";
import FormTextarea from "Common/Custom/FormTextarea";

/**
 * Status options aligned to DB CASE values:
 * 1 = Inactive, 2 = Active, 3 = Under Maintenance, 4 = Booked
 */
const poolStatusOptions = [
    { value: 1, label: "Inactive" },
    { value: 2, label: "Active" },
    { value: 3, label: "Under Maintenance" },
    { value: 4, label: "Booked" },
];

const AddSwimmingPoolForm = ({
    fields = [],
    values = {},
    errors = {},
    handleChange = () => {},
    handleSubmit = () => {},
    loading = false,
    poolTypeOptions = [],
}) => {
    return (
        <PageBody
            headerchildren={<HeadingOne>Create Swimming Pool</HeadingOne>}
            onSubmit={handleSubmit}
        >
            {fields.map((field) => {
                if (field.type === "select") {
                    let options = [];
                    if (field.name === "pool_type") {
                        // Guard against undefined while data is loading
                        options = (poolTypeOptions || []).map((opt) => ({
                            value: opt.pool_type_id,
                            label: opt.pool_type_name,
                        }));
                    }
                    if (field.name === "status") {
                        options = poolStatusOptions;
                    }
                    return (
                        <FormSelect
                            key={field.name}
                            field={field}
                            value={values[field.name]}
                            handleChange={handleChange}
                            options={options}
                            error={errors[field.name]}
                        />
                    );
                }
                if (field.type === "textarea") {
                    return (
                        <FormTextarea
                            key={field.name}
                            field={field}
                            value={values[field.name]}
                            handleChange={handleChange}
                            error={errors[field.name]}
                        />
                    );
                }
                return (
                    <FormInput
                        key={field.name}
                        field={field}
                        value={values[field.name]}
                        handleChange={handleChange}
                        error={errors[field.name]}
                    />
                );
            })}

            <FormSubmitButton
                label="Create Swimming Pool"
                loading={loading}
                colSize="col-12"
                align="end"
            />
        </PageBody>
    );
};

export default AddSwimmingPoolForm;
